import Vue from "vue";
import routes from "./routes/index.js";
import storeModule from "./store-module/index.js";
import login from "./utils/login.js";

export default {
    routes: routes,
    storeModule: storeModule,
    login,
    main() {
        const UA = navigator.userAgent.toLowerCase();
        Vue.prototype.$showTitle =
            UA.match(/MicroMessenger/i) == "micromessenger"
                ? UA.indexOf("android") > -1
                    ? true
                    : false
                : true;
        Vue.prototype.$bindInsurance = function(from) {
            this.$router.push(
                `/bind-policy-in-h5?keepScroll=true&from=${from ||
                    location.hash.replace("#/", "")}`
            );
        };
    },
};
